import { render } from "./app.vue?vue&type=template&id=5d87e7ea&lang=pug"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d87e7ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d87e7ea', __exports__)) {
    api.reload('5d87e7ea', __exports__)
  }
  
  module.hot.accept("./app.vue?vue&type=template&id=5d87e7ea&lang=pug", () => {
    api.rerender('5d87e7ea', render)
  })

}


export default __exports__